import { userClient } from './auth';
export async function getMypay() {
  return await userClient.get(`/my-pay/payment-infos`);
}

//마이페이 등록된 결제수단 조회
export async function getPaymentInfo() {
  return await userClient.get(`/my-pay/payment-infos`);
}
